import { render } from "./AssetsList.vue?vue&type=template&id=b4031d96"
import script from "./AssetsList.vue?vue&type=script&lang=js"
export * from "./AssetsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__